import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Routes } from './Routes';
import * as DotEnv from 'dotenv';
import config from "devextreme/core/config";
config({
    editorStylingMode: 'underlined' // or 'outlined' | 'underlined'
});
var rootElement = document.getElementById('root');
var root = createRoot(rootElement);
DotEnv.config();
root.render(React.createElement(Routes, null));
//# sourceMappingURL=index.js.map